if($('.flag-priplatky').length){
   // function loadData() {
        var domainName = window.location.hostname;
        var storageKey = 'JSONDATA' + domainName;
    
        if (!sessionStorage.getItem(storageKey)) {
            $.ajax({
                url: '/user/documents/data.json?v='+new Date().getHours(),
                type: 'GET',
                dataType: 'json',
                success: function(data) {
                    var storageObject = {};
                    $.each(data, function(index, item) {
                        if (item.CODE) {
                            storageObject[item.CODE] = item;
                        }
                    });
                    sessionStorage.setItem(storageKey, JSON.stringify(storageObject));
                    processData(storageKey);
                },
                error: function(xhr, status, error) {
                    console.error("Nastala chyba při stahování dat: ", error);
                }
            });
        } else {
            processData(storageKey);
        }
 //   }
    
    function processData(storageKey) {
        var storedData = JSON.parse(sessionStorage.getItem(storageKey));
    
        $('.detail-parameters tr').each(function() {
            var $tr = $(this);
            var text = $tr.find('th>span').text();
    
            if (text.indexOf('#POMOCNE') !== -1) {
                var title = text.replace('#POMOCNE_', '').trim();
                var $td = $tr.find('td');
                
                var select = $('<select title-id="'+title.split('_URL')[0].normalize('NFD').replace(/[^\w]/g, '').toLowerCase()+'"></select>').append($('<option>', { text: 'Vyberte', value: '' }));
                if (title.includes('*')) {
                    select.attr('required', true); // Přidání atributu required, pokud title obsahuje *
                    title = title.replace('*', '').trim(); // Odstranění * ze jména pro zobrazení
                }
                if (title.includes('_URL')) {
                    title = title.split('_URL-')[0].trim(); // Odstranění * ze jména pro zobrazení
                    var urlProduct = text.replace('#POMOCNE_', '').trim().split('_URL-')[1].trim().replace(':', '');
                }
    
                $td.text().split(',').forEach(function(code) {
                    code = code.trim();
                    if (storedData[code]) {
                        //if(storedData[code].STOCK_AMOUNT>0){
                            select.append($('<option></option>').attr('value', code).text(storedData[code].PRODUCT.replace(title.replace(':', ''), '')));
                        //}
                        
                    }
                });

                var selectHtml = $('<div></div>').append(select).html(); // Převod jQuery select objektu na HTML řetězec
                var customSelectDiv = '<div class="custom-select">'
                if (text.replace('#POMOCNE_', '').trim().includes('_URL')) {
                    customSelectDiv += '<label>' + title+' - <a href="'+urlProduct+'" target="_blank">Info o produktu</a></label>'
                }
                else{
                    customSelectDiv += '<label>' + title+'</label>'
                }
                customSelectDiv += selectHtml+'</div>'
                
                var $pInfoWrapper = $('#product-detail-form .p-variants-block');
                $pInfoWrapper.append(customSelectDiv);
                if(!$('.admin-logged').length){
                    $(this).hide()
                }
            }

        });
    }
    
   /* $(document).ready(function() {
        loadData();
    });*/

    $('html').on('click', '.p-to-cart-block .add-to-cart-button', function(){
        $('.custom-select select').each(function(){
            var selectedValue = $(this).find('option:selected').attr('value');
            console.log(selectedValue)
            if (selectedValue) {
                shoptet.cartShared.addToCart({productCode: ''+selectedValue+''}, true);
            } 
        })
    })   

       // Shromažďujeme všechna title-id z dependencies pro skrytí
       function gatherTitleIdsToHide() {
        let toHide = new Set();
        Object.keys(dependencies).forEach(parameterId => {
            Object.values(dependencies[parameterId]).forEach(condition => {
                Object.values(condition).forEach(option => {
                    Object.values(option).forEach(ids => {
                        ids.forEach(id => toHide.add(id));
                    });
                });
            });
        });
        return toHide;
    }

    // Skrytí specifikovaných select elementů s title-id
    function hideSpecifiedSelects() {
        let toHide = gatherTitleIdsToHide(); // Získáme set title-id k skrytí
        $('select[title-id]').each(function() {
            let titleId = $(this).attr('title-id');
            if (toHide.has(titleId)) {
                $(this).closest('.custom-select').hide();
            }
        });
    }

    // Funkce pro aktualizaci závislých selectů
    function updateDependencies() {
        $('select[data-parameter-id]').each(function() {
            var parameterId = $(this).data('parameter-id');
            var selectedValue = $(this).val();

            // Dynamicky určíme, jaké hodnoty a data-parameter-id mít speciální zacházení
            if (dependencies[parameterId] && !dependencies[parameterId][selectedValue]) {
                let allDependentIds = gatherTitleIdsToHide();
                allDependentIds.forEach(id => {
                    $('select[title-id="' + id + '"]').closest('.custom-select').hide();
                    $('select[title-id="' + id + '"]').val($('select[title-id="' + id + '"]').find('option:first').val());
                    $('select[title-id="' + id + '"]').removeAttr('required');
                });
            } else if (dependencies[parameterId] && dependencies[parameterId][selectedValue]) {
                Object.keys(dependencies[parameterId][selectedValue]).forEach(depId => {
                    var text = $('select[data-parameter-id="' + depId + '"]').find('option:selected').text();
                    var condition = text.includes('x') ? 'x' : 'default';
                    let toShow = dependencies[parameterId][selectedValue][depId][condition];
                    $('select[title-id]').closest('.custom-select').hide();
                    $('select[title-id]').removeAttr('required');
                    toShow.forEach(titleId => {
                        $('select[title-id="' + titleId + '"]').closest('.custom-select').show();
                        $('select[title-id="' + titleId + '"]').attr('required', 'required');
                    });
                });
            }
        });
    }

    // Inicializace
    $(document).ready(function() {
        hideSpecifiedSelects();  // Skryjeme specifikované selecty při načtení stránky
        $('select[data-parameter-id]').change(updateDependencies); // Posluchač změn
        updateDependencies(); // Aktualizujeme závislosti při načtení stránky
    });


    
}